import { render } from "./Bar10Charts.vue?vue&type=template&id=33b8f90a&scoped=true"
import script from "./Bar10Charts.vue?vue&type=script&lang=js"
export * from "./Bar10Charts.vue?vue&type=script&lang=js"

import "./Bar10Charts.vue?vue&type=style&index=0&id=33b8f90a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b8f90a"]])

export default __exports__